import { Tooltip as AntTooltip } from 'antd';
import useIsMobile from '@/hooks/useIsMobile';

export default function Tooltip({ disabled = false, ...props }) {
  const isMobile = useIsMobile();

  if (disabled) {
    return props.children;
  }

  return <AntTooltip trigger={isMobile ? 'click' : 'hover'} {...props} />;
}
